import { Link } from "react-router-dom";
import { AppShell } from "@/components/app/AppShell";
import { useCredits } from "@/context/CreditsContext";

export default function PaymentCancelled() {
  const { openBuy } = useCredits();
  return (
    <AppShell>
      <div data-testid="payment-cancelled-root" className="mx-auto max-w-md py-16 text-center">
        <h1 className="font-display text-2xl font-semibold text-brand-text">Płatność anulowana</h1>
        <p className="mt-2 text-brand-sec">Nie obciążyliśmy Twojego konta. Możesz spróbować ponownie w dowolnej chwili.</p>
        <button
          type="button"
          onClick={openBuy}
          className="mt-6 inline-flex items-center justify-center rounded-button bg-brand-accent px-6 py-3 text-sm font-semibold text-brand-on"
        >
          Kup kredyty
        </button>
        <Link to="/biblioteka" className="mt-3 block text-sm text-brand-sec hover:text-brand-text">
          Wróć do biblioteki
        </Link>
      </div>
    </AppShell>
  );
}
